<div class="pdf-page-container signing-container">
  <!--
    Consent banner, above the document. It does not cover the page: the document
    stays readable so a signer can decide, and Decline stays reachable in the navbar the whole
    time. What is withheld is getDocFields(), so there are no signature overlays to click.

    It is a child of .pdf-page-container (flex COLUMN), never of .pdf-page-content — that one is
    flex ROW, so a banner placed inside it becomes a second column beside the document and steals
    its width instead of sitting above it.
  -->
  @if (disclosureGateOpen && disclosure) {
    <div class="signing-disclosure-gate">
      <app-disclosure-consent
        [consentText]="disclosure.consentText"
        [disclosureTitle]="'Electronic Record and Signature Disclosure' | translate"
        [submitting]="disclosureSubmitting"
        (openRequested)="openDisclosureModal()"
        (accepted)="acceptDisclosure()">
      </app-disclosure-consent>
    </div>
  }

  <app-disclosure-modal
    [visible]="disclosureModalVisible"
    [title]="'Electronic Record and Signature Disclosure' | translate"
    [body]="disclosure?.body"
    [loading]="disclosureLoading"
    (closed)="closeDisclosureModal()">
  </app-disclosure-modal>

  <!-- Page content -->
  <div class="pdf-page-content">

    <div class="pdf-content-area text-center" *ngIf="pdfSrc.url!=''">

      <!-- ng2-pdf-viewer -->
      <pdf-viewer #ng2PdfViewer
                  [src]="pdfSrc.url"
                  (after-load-complete)="afterLoadComplete($event)"
                  (page-rendered)="onPageRendered($event)"
                  [show-all]="true"
                  [zoom]="zoom"
                  [render-text]="false"
                  [external-link-target]="'blank'"
                  (error)="onError($event)">
      </pdf-viewer>

      <!-- HTML Form Field Overlays are now created dynamically per-page -->

    </div>
  </div>
</div>

<!-- Filling helper. Outside .pdf-page-container so the viewer's overflow cannot clip it.
     Hidden when the signer has no traversable field (e.g. a QES-only signer): a bar that can only
     ever read "0 left" next to a blocked Approve would be its own defect. -->
<sd-filling-helper
  *ngIf="fieldsLoaded && hasFillingStops"
  [started]="fillingStarted"
  [remaining]="remainingMandatory()"
  (start)="onFillingStart()"
  (next)="onFillingNext()"
  (previous)="onFillingPrevious()">
</sd-filling-helper>

<!-- Unified Digital Signer Modal Component -->
<app-digital-signer-modal
  #digitalSignerModal
  [requestCode]="requestCode"
  [theJob]="theJob"
  [theRecipient]="theRecipient"
  [enabledMethods]="['usb', 'mobile']"
  [showReasonLocation]="true"
  (signComplete)="onSignComplete($event)"
  (signCancelled)="onSignCancelled()"
  (signRejected)="onSignRejected()">
</app-digital-signer-modal>

<div id="bioSignModal" class="modal fade" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog biosignModal" >
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h6 class="modal-title" *ngIf="selectedField == null || selectedField.type != 'initials'" translate>Prepare Basic (eIDAS) Signature</h6>
        <h6 class="modal-title" *ngIf="selectedField != null && selectedField.type == 'initials'">{{"Prepare Initials" | translate}}</h6>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <ul id="bio-sign-tabs" class="nav nav-tabs nav-tabs-highlight">
              <li [class.active]="bioSignSelection=='list'"><a (click)="bioSignSelection='list'" data-toggle="tab" href="#bioList" translate>Last Used</a></li>
              <li [class.active]="bioSignSelection=='draw'"><a (click)="bioSignSelection='draw'" data-toggle="tab" href="#bioDraw" translate>Draw</a></li>
              <li [class.active]="bioSignSelection=='upload'"><a (click)="bioSignSelection='upload'" data-toggle="tab" href="#bioUpload" translate>Upload file</a></li>
              <li [class.active]="bioSignSelection=='styles'"><a (click)="bioSignSelection='styles'" data-toggle="tab" href="#bioStyles" translate>Ready Styles</a></li>
            </ul>

            <div id="bio-signature" class="tab-content">
              <div id="bioList" class="tab-pane fade" [class.active]="bioSignSelection=='list'" [class.in]="bioSignSelection=='list'">
                <a [attr.href]=null *ngFor="let signature of usedSignatures; trackBy: trackBySignature" class="gallery-box" [ngStyle]="{'border': signatureListSelection==signature ? 'solid 1px darkred' : 'solid 1px lightgrey'}" (click)="signatureListSelection=signature">
                  <img [src]="domSanitizer.bypassSecurityTrustUrl(signature)" class="gallery-image">
                </a>
              </div>
              <div id="bioDraw" class="tab-pane fade" [class.active]="bioSignSelection=='draw'" [class.in]="bioSignSelection=='draw'">
                <div [ngClass]="{'signature-pad-wrapper':(selectedField != null && selectedField.type == 'bio-sign'),'initials-pad-wrapper':(selectedField != null && selectedField.type == 'initials')}">
                  <signature-pad *ngIf="signaturePadOptions!=null"
                    #signaturePad [options]="signaturePadOptions"
                    [ngClass]="{'signature-pad':(selectedField != null && selectedField.type == 'bio-sign'),'initials-pad':(selectedField != null && selectedField.type == 'initials')}">

                  </signature-pad>
                  <!-- <canvas id="signature-pad" [ngClass]="{'signature-pad':(selectedField != null && selectedField.type == 'bio-sign'),'initials-pad':(selectedField != null && selectedField.type == 'initials')}" [width]="(selectedField != null && selectedField.type == 'bio-sign') ? 600 : 300" height=200></canvas> -->
                </div>
              </div>
              <div id="bioUpload" class="tab-pane fade text-center" [class.active]="bioSignSelection=='upload'" [class.in]="bioSignSelection=='upload'">
               <div *ngIf="signatureFile===null">
                  <br><br><br>
                  <p><strong [hidden]="selectedField != null && selectedField.type == 'initials'" translate>Upload Signature Image</strong></p>
                  <p><strong [hidden]="selectedField != null && selectedField.type == 'bio-sign'" translate>Upload Initials Image</strong></p>
                  <label class="btn btn-file btn-primary btn-size">
                    <span translate>Browse</span>
                    <input id="signature-file"
                      type="file"
                      accept="image/*"
                      (change)="showSignature($event)"
                      style="display: none;">
                  </label>
                  <br>
                </div>
                <img id="output" [style.visibility]="signatureFile ? 'visible' : 'hidden'"/>
                <br *ngIf="uploadError">
                <p><strong class="text-danger">{{uploadError}}</strong></p>
              </div>
              <div id="bioStyles" class="tab-pane fade" [class.active]="bioSignSelection=='styles'" [class.in]="bioSignSelection=='styles'">
                <div class="row">
                  <div class="col-md-1 col-xs-1"></div>
                  <div class="col-md-7 col-xs-7">
                    <label style="font-size: 20px; font-weight: bold;" translate>Initials:</label>
                    <input #styles="ngModel" [(ngModel)]="stylesInput" id="stylesInput" name="stylesInput" type="text" [maxLength]="(selectedField != null && selectedField.type == 'initials') ? 5 : 20" class="form-control" style="width: auto; display:inline;" (ngModelChange)="updateStylesCanvas();"/>
                  </div>
                  <div class="col-md-4 col-xs-4"></div>
                </div>
                <div class="row" style="text-align: center; margin: 15px;">
                  <div class="col-md-2 col-xs-2" (click)="changeFont(false)" [ngStyle]="{'cursor':this.stylesFontIndex == 0? 'not-allowed' : 'pointer', 'opacity':this.stylesFontIndex == 0 ? 0.5 : 1.0, 'top.px':70}">
                    <i class="icon-arrow-left15" style="font-size: 60px;"></i>
                  </div>
                  <div class="col-md-8 col-xs-8" style="text-align: center;">
                    <canvas id="stylesCanvas" name="stylesCanvas" style="border: 1px solid black;width: 300px;height: 200px;"></canvas>
                  </div>
                  <div class="col-md-2 col-xs-2" (click)="changeFont(true)" [ngStyle]="{'cursor':this.stylesFontIndex == this.stylesFonts.length - 1 ? 'not-allowed' : 'pointer', 'opacity':this.stylesFontIndex == this.stylesFonts.length - 1 ? 0.5 : 1.0, 'top.px':70}">
                    <i class="icon-arrow-right15" style="font-size: 60px;"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button *ngIf="bioSignSelection=='draw'" class="btn btn-danger pull-left" (click)="clearSignaturePad()" translate>Clear</button>
            <button type="button" class="btn btn-default" data-dismiss="modal" translate>Cancel</button>
            <button class="btn btn-primary" [disabled]="isBioUseDisabled" (click)="useSignature()" *ngIf="selectedField != null && selectedField.type != 'initials'" translate>Use</button>
            <button class="btn btn-primary" [disabled]="isBioUseDisabled" (click)="useInitials()" *ngIf="selectedField != null && selectedField.type != 'bio-sign'" translate>Use</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="smsVerificationModal" class="modal fade" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg" style="max-width: 670px;">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button type="button" class="close" (click)="closeSmsVerificationModal()">&times;</button>
        <h6 class="modal-title">{{'SMS Verification' | translate}}</h6>
      </div>
      <form #f="ngForm" novalidate>
        <div class="modal-body">
          <div class="container-fluid">
            <p style="text-align: center;" translate [translateParams]="{phoneNumber:theRecipient == null ? '' : '(+' + theRecipient.smsCountryCode + ') ' + theRecipient.smsRequired}">MOBILE_OTP_SEND_TEXT</p>
            <br>
            <div class="row">
              <div class="col-md-1"></div>
              <div class="col-md-4">
                <input type="text" id="smsCode" name="smsCode" #smsCode="ngModel" [(ngModel)]="smsOTPCode" class="form-control otp-input" [disabled]="disableSmsVerify" minlength="6" maxlength="6" pattern="[0-9]+" required>
              </div>
              <div class="col-md-1"></div>
              <div class="col-md-2" style="color:red; font-size: 15px; margin-top: 7px;">
                {{smsVerificationTimeText}}
              </div>
              <div class="col-md-3 "style="color:red; font-size: 15px; margin-top: 7px;">
                <a (click)="resendSmsCode()" [ngClass]="{'disabled-link':disableResendSMSButton}">{{'Send Code Again' | translate}}</a>
              </div>
            </div>
            <hr>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" (click)="closeSmsVerificationModal()" translate>Cancel</button>
              <button type="button" class="btn btn-primary" (click)="bioSignatureApiCall(this.smsOTPCode)" [disabled]="disableSmsVerify || !f.valid">{{'Verify' | translate}}</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Attachments Modal (recipient read-only) -->
<div *ngIf="attachmentsModalVisibility">
  <app-attachments-modal
    [requestCode]="requestCode"
    [editable]="false"
    [jobName]="theJob?.name"
    (modalClosed)="onAttachmentsClosed()">
  </app-attachments-modal>
</div>
